import { render, staticRenderFns } from "./tab-resume.vue?vue&type=template&id=3a24a12e"
import script from "./tab-resume.vue?vue&type=script&lang=js"
export * from "./tab-resume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports